export const EN = "en";
export const CN = "cn";
export const MM = "mm";
export const THAI = "thai";
export const CURRENT_LANG = "i18nextLng";

